import { io } from 'socket.io-client';

const URL = process.env.REACT_APP_BASE_URL;
// console.log("Socket connecting to:", URL);

export const socket = io(URL, {
  autoConnect: false,
  transports: ['websocket', 'polling'], 

  reconnection: true,
  reconnectionAttempts: 20, 
  reconnectionDelay: 2000,
  path: "/socket.io", 
});